import { validateResponse } from "../../response.js";
import { acceptJson } from "../../shared.js";
import { placePredictionsResponseSpec } from "./specs.js";
const getPlacePredictions = async (apiUrl, request) => {
  return validateResponse(
    placePredictionsResponseSpec,
    await fetch(`${apiUrl}/place/predictions?name=${request.place}`, {
      method: "GET",
      headers: {
        ...acceptJson
      }
    })
  );
};
export {
  getPlacePredictions
};
//# sourceMappingURL=place-predictions.js.map
